import React from 'react';

import ArrowDown from 'assets/images/arrow-down.svg';

import BaseIcon from './BaseIcon';

const ArrowDownIcon = props => <BaseIcon {...props} src={ArrowDown} />;

export default ArrowDownIcon;
